import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private isModalOpenSubject$ = new BehaviorSubject(false);
  readonly isModalOpen$ = this.isModalOpenSubject$.asObservable();

  setModalState(modalOpen: boolean) {
    this.isModalOpenSubject$.next(modalOpen);
  }
}
